var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watermarkContainer",style:({opacity: _vm.opacity})},[_c('div',{staticClass:"watermark",style:({backgroundImage: `url('${_vm.url}')`})})])
}
var staticRenderFns = []

export { render, staticRenderFns }